export { ReactComponent as Cross } from './svgs/cross.svg';
